///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectWindowsPopupService } from '../project-windows-popup.service';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { feetMultiplier, squareFeetMultiplier } from '../../../shared/utils';
import { ActiveRestorableWindow } from '../active-restorable-window';
import { MatDialogRef } from '@angular/material/dialog';
import { SuiTypeNumber } from '@siklu/sui-lib/infrastructure';

@Component({
    selector: 'winde-house-detection-modal',
    templateUrl: './house-detection-modal.component.html',
    styleUrls: ['./house-detection-modal.component.scss'],
    standalone: false
})
export class GtthHouseDetectionModalComponent extends ActiveRestorableWindow implements OnInit, OnDestroy {
    public projectUnits: string;
    public duplicateDistance: SuiTypeNumber;
    public areaThresholdLow: SuiTypeNumber;
    public areaThresholdHigh: SuiTypeNumber;

    constructor(
        public dialogRef: MatDialogRef<GtthHouseDetectionModalComponent>,
        public readonly historyService: GtthHistoryService
    ) {
        super();
    }

    ngOnInit(): void {
        const config = this.historyService.logicalTopology.houseDetectionConfig;
        let duplicationDistance = config.duplicateDistance;
        let areaLowTh = config.areaThresholdLow;
        let areaHighTh = config.areaThresholdHigh;

        this.projectUnits = this.historyService.logicalTopology.productUnits;

        if (this.projectUnits === 'feet') {
            duplicationDistance = Math.round(duplicationDistance * feetMultiplier);
            areaLowTh = Math.round(areaLowTh * squareFeetMultiplier);
            areaHighTh = Math.round(areaHighTh * squareFeetMultiplier);
        }

        this.duplicateDistance = new SuiTypeNumber(duplicationDistance, 0, 0);
        this.areaThresholdLow = new SuiTypeNumber(areaLowTh, 0, 0);
        this.areaThresholdHigh = new SuiTypeNumber(areaHighTh, 0, 0);
    }

    ngOnDestroy(): void {
        if (
            this.duplicateDistance.valid() &&
            this.areaThresholdLow.valid() &&
            this.areaThresholdHigh.valid() &&
            this.historyService.logicalTopology
        ) {
            let duplicationDisatnce = this.duplicateDistance.value;
            let areaLowTh = this.areaThresholdLow.value;
            let areaHighTh = this.areaThresholdHigh.value;

            if (this.projectUnits === 'feet') {
                duplicationDisatnce = Math.round(duplicationDisatnce / feetMultiplier);
                areaLowTh = Math.round(areaLowTh / squareFeetMultiplier);
                areaHighTh = Math.round(areaHighTh / squareFeetMultiplier);
            }

            this.historyService.logicalTopology.houseDetectionConfig.duplicateDistance = duplicationDisatnce;
            this.historyService.logicalTopology.houseDetectionConfig.areaThresholdLow = areaLowTh;
            this.historyService.logicalTopology.houseDetectionConfig.areaThresholdHigh = areaHighTh;
        }
    }

    closeModal() {
        this.dialogRef.close('cancel');
    }

    designRequired(): boolean {
        return false;
    }

    isRestorable(): boolean {
        return true;
    }
}

@Component({
    selector: 'winde-house-detection-modal-popup',
    template: '',
    standalone: false
})
export class GtthHouseDetectionPopupComponent implements OnInit {
    constructor(private readonly projectWindowsPopupService: ProjectWindowsPopupService) {}

    ngOnInit() {
        this.projectWindowsPopupService.openWindow(GtthHouseDetectionModalComponent, 'sm');
    }
}
